import React, {
  useContext,
  useEffect,
  useReducer,
  useState,
  useRef,
} from "react";
import { Link, useLocation } from "react-router-dom";
import useHelps from "../hooks/useHelps";
import Tooltip from "@material-ui/core/Tooltip";

import {
  BarChart3,
  MessageSquare,
  Zap,
  Columns,
  User,
  Clock,
  Tag,
  HelpCircle,
  Settings,
  Users,
  ListOrdered,
  ArrowLeftRight,
  Server,
  Paperclip,
  Building2,
  ChevronDown,
  ChevronRight,
  FileText,
  Table,
  List,
  UsersRound,
  Megaphone,
  MessagesSquare,
  Info,
  Code,
  Sparkles,
  Cable,
  Home,
  Cog,
  AlertTriangle,
  Wifi,
  WifiOff,
  Workflow,
  Mic,
  Briefcase,
  Shield,
  HardDrive,
  Database,
  CreditCard,
  Ban,
  FileStack,
  Coffee,
  Star,
  DollarSign,
  UtensilsCrossed,
  ShoppingBag,
  Percent,
  Wallet,
  ClipboardList,
  TrendingUp,
  BarChart2,
  Filter,
  PhoneIncoming,
  Wrench,
  Bot,
  Globe,
  FlaskConical,
  Smartphone,
} from "lucide-react";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { useActiveMenu } from "../context/ActiveMenuContext";
import ColorModeContext from "../layout/themeContext";

import { isArray } from "lodash";
import api from "../services/api";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import useVersion from "../hooks/useVersion";
import { i18n } from "../translate/i18n";
import { isAdminProfile, isFullAdmin } from "../helpers/userPermissions";
import "./mainListItems.css";

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

const MainListItems = ({ isMobile = false, closeDrawer }) => {
  const colorModeContext = useContext(ColorModeContext);
  const isDarkMode = colorModeContext.mode === "dark";
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, socket } = useContext(AuthContext);
  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const [showSchedules, setShowSchedules] = useState(false);
  const [showGoogleCalendar, setShowGoogleCalendar] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [showInternalChat, setShowInternalChat] = useState(false);
  const [showExternalApi, setShowExternalApi] = useState(false);
  const [showContactWallet, setShowContactWallet] = useState(false);
  const [showIFood, setShowIFood] = useState(false); // ✅ Módulo iFood
  // eslint-disable-next-line no-unused-vars
  const [showSipPhone, setShowSipPhone] = useState(false); // ✅ Módulo SIP Phone
  // eslint-disable-next-line no-unused-vars
  const [showWaba, setShowWaba] = useState(false); // ✅ Templates WABA (API Oficial)
  // eslint-disable-next-line no-unused-vars
  const [showEmail, setShowEmail] = useState(false); // ✅ Módulo Email
  const [showWhatsAppGroups, setShowWhatsAppGroups] = useState(false); // ✅ Grupos WhatsApp (apenas wuzapi/whatsmeow)
  const [showWhatsAppCommunities, setShowWhatsAppCommunities] = useState(false); // ✅ Comunidades WhatsApp (apenas whatsmeow)

  // eslint-disable-next-line no-unused-vars
  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  // eslint-disable-next-line no-unused-vars
  const [version, setVersion] = useState(false);
  const { list } = useHelps();
  const [hasHelps, setHasHelps] = useState(false);

  const [managementMenuOpen, setManagementMenuOpen] = useState(false);
  const [ticketsMenuOpen, setTicketsMenuOpen] = useState(false);
  const [campaignsMenuOpen, setCampaignsMenuOpen] = useState(false);
  const [adminMenuOpen, setAdminMenuOpen] = useState(false);
  const [automationMenuOpen, setAutomationMenuOpen] = useState(false);
  const [connectionsMenuOpen, setConnectionsMenuOpen] = useState(false);
  const [ifoodMenuOpen, setIfoodMenuOpen] = useState(false);
  const [funnelSubmenuOpen, setFunnelSubmenuOpen] = useState(false); // Submenu Funil

  const managementMenuRef = useRef(null);
  const managementButtonRef = useRef(null);
  const ticketsMenuRef = useRef(null);
  const ticketsButtonRef = useRef(null);
  const campaignsMenuRef = useRef(null);
  const campaignsButtonRef = useRef(null);
  const adminMenuRef = useRef(null);
  const adminButtonRef = useRef(null);
  const automationMenuRef = useRef(null);
  const automationButtonRef = useRef(null);
  const connectionsMenuRef = useRef(null);
  const connectionsButtonRef = useRef(null);
  const ifoodMenuRef = useRef(null);
  const ifoodButtonRef = useRef(null);

  const managementContainerRef = useRef(null);
  const ticketsContainerRef = useRef(null);
  const campaignsContainerRef = useRef(null);
  const adminContainerRef = useRef(null);
  const automationContainerRef = useRef(null);
  const connectionsContainerRef = useRef(null);

  useEffect(() => {
    if (isMobile) {
      function handleClickOutside(event) {
        if (
          managementMenuOpen &&
          managementButtonRef.current &&
          !managementButtonRef.current.contains(event.target) &&
          managementMenuRef.current &&
          !managementMenuRef.current.contains(event.target)
        ) {
          setManagementMenuOpen(false);
        }

        if (
          ticketsMenuOpen &&
          ticketsButtonRef.current &&
          !ticketsButtonRef.current.contains(event.target) &&
          ticketsMenuRef.current &&
          !ticketsMenuRef.current.contains(event.target)
        ) {
          setTicketsMenuOpen(false);
        }

        if (
          campaignsMenuOpen &&
          campaignsButtonRef.current &&
          !campaignsButtonRef.current.contains(event.target) &&
          campaignsMenuRef.current &&
          !campaignsMenuRef.current.contains(event.target)
        ) {
          setCampaignsMenuOpen(false);
        }

        if (
          adminMenuOpen &&
          adminButtonRef.current &&
          !adminButtonRef.current.contains(event.target) &&
          adminMenuRef.current &&
          !adminMenuRef.current.contains(event.target)
        ) {
          setAdminMenuOpen(false);
        }

        if (
          automationMenuOpen &&
          automationButtonRef.current &&
          !automationButtonRef.current.contains(event.target) &&
          automationMenuRef.current &&
          !automationMenuRef.current.contains(event.target)
        ) {
          setAutomationMenuOpen(false);
        }

        if (
          connectionsMenuOpen &&
          connectionsButtonRef.current &&
          !connectionsButtonRef.current.contains(event.target) &&
          connectionsMenuRef.current &&
          !connectionsMenuRef.current.contains(event.target)
        ) {
          setConnectionsMenuOpen(false);
        }

        if (
          ifoodMenuOpen &&
          ifoodButtonRef.current &&
          !ifoodButtonRef.current.contains(event.target) &&
          ifoodMenuRef.current &&
          !ifoodMenuRef.current.contains(event.target)
        ) {
          setIfoodMenuOpen(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [
    managementMenuOpen,
    ticketsMenuOpen,
    campaignsMenuOpen,
    adminMenuOpen,
    automationMenuOpen,
    connectionsMenuOpen,
    ifoodMenuOpen,
    isMobile,
  ]);

  const closeAllMenus = () => {
    setManagementMenuOpen(false);
    setTicketsMenuOpen(false);
    setCampaignsMenuOpen(false);
    setAdminMenuOpen(false);
    setAutomationMenuOpen(false);
    setConnectionsMenuOpen(false);
    setIfoodMenuOpen(false);

    if (isMobile && closeDrawer) {
      closeDrawer();
    }
  };

  const handleMenuItemClick = (to) => {
    if (isMobile && closeDrawer) {
      closeDrawer();
    }
    closeAllMenus();
  };

  const toggleManagementMenu = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();

      if (managementMenuOpen && isManagementActive && closeDrawer) {
        closeDrawer();
        return;
      }

      setManagementMenuOpen(!managementMenuOpen);
      setTicketsMenuOpen(false);
      setCampaignsMenuOpen(false);
      setAdminMenuOpen(false);
      setAutomationMenuOpen(false);
      setConnectionsMenuOpen(false);
      setIfoodMenuOpen(false);
    }
  };

  const toggleTicketsMenu = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();

      if (ticketsMenuOpen && isTicketsActive && closeDrawer) {
        closeDrawer();
        return;
      }

      setTicketsMenuOpen(!ticketsMenuOpen);
      setManagementMenuOpen(false);
      setCampaignsMenuOpen(false);
      setAdminMenuOpen(false);
      setAutomationMenuOpen(false);
      setConnectionsMenuOpen(false);
      setIfoodMenuOpen(false);
    }
  };

  const toggleCampaignsMenu = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();

      if (campaignsMenuOpen && isCampaignRouteActive && closeDrawer) {
        closeDrawer();
        return;
      }

      setCampaignsMenuOpen(!campaignsMenuOpen);
      setManagementMenuOpen(false);
      setTicketsMenuOpen(false);
      setAdminMenuOpen(false);
      setAutomationMenuOpen(false);
      setConnectionsMenuOpen(false);
      setIfoodMenuOpen(false);
    }
  };

  const toggleAdminMenu = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();

      if (adminMenuOpen && isAdminActive && closeDrawer) {
        closeDrawer();
        return;
      }

      setAdminMenuOpen(!adminMenuOpen);
      setManagementMenuOpen(false);
      setTicketsMenuOpen(false);
      setCampaignsMenuOpen(false);
      setAutomationMenuOpen(false);
      setConnectionsMenuOpen(false);
      setIfoodMenuOpen(false);
    }
  };

  const toggleAutomationMenu = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();

      if (automationMenuOpen && isAutomationActive && closeDrawer) {
        closeDrawer();
        return;
      }

      setAutomationMenuOpen(!automationMenuOpen);
      setManagementMenuOpen(false);
      setTicketsMenuOpen(false);
      setCampaignsMenuOpen(false);
      setAdminMenuOpen(false);
      setConnectionsMenuOpen(false);
      setIfoodMenuOpen(false);
    }
  };

  const toggleConnectionsMenu = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();

      if (connectionsMenuOpen && isConnectionsActive && closeDrawer) {
        closeDrawer();
        return;
      }

      setConnectionsMenuOpen(!connectionsMenuOpen);
      setManagementMenuOpen(false);
      setTicketsMenuOpen(false);
      setCampaignsMenuOpen(false);
      setAdminMenuOpen(false);
      setAutomationMenuOpen(false);
      setIfoodMenuOpen(false);
    }
  };

  const toggleIfoodMenu = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();

      if (ifoodMenuOpen && isIfoodActive && closeDrawer) {
        closeDrawer();
        return;
      }

      setIfoodMenuOpen(!ifoodMenuOpen);
      setManagementMenuOpen(false);
      setTicketsMenuOpen(false);
      setCampaignsMenuOpen(false);
      setAdminMenuOpen(false);
      setAutomationMenuOpen(false);
      setConnectionsMenuOpen(false);
    }
  };

  const isManagementActive =
    location.pathname === "/dashboard" ||
    location.pathname.startsWith("/reports") ||
    location.pathname.startsWith("/moments") ||
    location.pathname.startsWith("/tasks") ||
    location.pathname.startsWith("/leads") ||
    location.pathname.startsWith("/automations") ||
    location.pathname.startsWith("/journey") ||
    location.pathname.startsWith("/kanban") ||
    location.pathname.startsWith("/smart-ai-dashboard") ||
    location.pathname.startsWith("/ticket-classification") ||
    location.pathname.startsWith("/ticket-tabs-settings");
  
  // Verificar se alguma rota do submenu Funil está ativa
  const isFunnelActive =
    location.pathname.startsWith("/kanban") ||
    location.pathname.startsWith("/leads") ||
    location.pathname.startsWith("/automations") ||
    location.pathname.startsWith("/journey");

  const isTicketsActive =
    location.pathname.startsWith("/tickets") ||
    location.pathname.startsWith("/quick-messages") ||
    location.pathname.startsWith("/contacts") ||
    location.pathname.startsWith("/schedules") ||
    location.pathname.startsWith("/callbacks") ||
    location.pathname.startsWith("/tags") ||
    location.pathname.startsWith("/chats") ||
    location.pathname.startsWith("/helps");

  const isCampaignRouteActive =
    location.pathname === "/campaigns" ||
    location.pathname.startsWith("/contact-lists") ||
    location.pathname.startsWith("/campaigns-config");

  const isAdminActive =
    location.pathname.startsWith("/users") ||
    location.pathname.startsWith("/queues") ||
    location.pathname.startsWith("/files") ||
    location.pathname.startsWith("/financeiro") ||
    location.pathname.startsWith("/settings") ||
    location.pathname.startsWith("/companies") ||
    location.pathname.startsWith("/admin-financeiro") ||
    location.pathname.startsWith("/announcements") ||
    location.pathname.startsWith("/messages-api") ||
    location.pathname.startsWith("/backup-restore") ||
    location.pathname.startsWith("/audit-logs");

  const isAutomationActive =
    location.pathname.startsWith("/queue-integration") ||
    location.pathname.startsWith("/integrations/google-speech") ||
    location.pathname.startsWith("/integrations/voice-api") ||
    location.pathname.startsWith("/flows") ||
    location.pathname.startsWith("/messages-api") ||
    location.pathname.startsWith("/ai-configurations") ||
    location.pathname.startsWith("/ai-tools") ||
    location.pathname.startsWith("/ai-tools/web-sessions") ||
    location.pathname.startsWith("/ai-playground");

  const isConnectionsActive =
    location.pathname.startsWith("/connections") ||
    location.pathname.startsWith("/allConnections") ||
    location.pathname.startsWith("/whatsapp-flows") ||
    location.pathname.startsWith("/contact-wallets") ||
    location.pathname.startsWith("/email-connections") ||
    location.pathname.startsWith("/email-templates") || // Acessível via card de email
    location.pathname.startsWith("/whatsapp-groups");

  const isIfoodActive =
    location.pathname.startsWith("/ifood");

  const { getPlanCompany } = usePlans();
  const { getVersion } = useVersion();

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function checkHelps() {
      const helps = await list();
      setHasHelps(helps.length > 0);
    }
    checkHelps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handler = async () => {
      try {
        const helps = await list();
        setHasHelps(helps.length > 0);
      } catch (_) {}
    };
    document.addEventListener("helps:changed", handler);
    return () => document.removeEventListener("helps:changed", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      if (!companyId) return;

      try {
        const planConfigs = await getPlanCompany(undefined, companyId);

        if (planConfigs && planConfigs.plan) {
          setShowCampaigns(planConfigs.plan.useCampaigns);
          setShowKanban(planConfigs.plan.useKanban);
          setShowOpenAi(planConfigs.plan.useOpenAi);
          setShowIntegrations(planConfigs.plan.useIntegrations);
          setShowSchedules(planConfigs.plan.useSchedules);
          setShowInternalChat(planConfigs.plan.useInternalChat);
          setShowExternalApi(planConfigs.plan.useExternalApi);
          setShowIFood(planConfigs.plan.useIFood); // ✅ Módulo iFood
          setShowSipPhone(planConfigs.plan.useSipPhone); // ✅ Módulo SIP Phone
          setShowWaba(planConfigs.plan.useWaba); // ✅ Templates WABA (API Oficial)
          setShowEmail(planConfigs.plan.useEmail); // ✅ Módulo Email
          setShowGoogleCalendar(planConfigs.plan.useGoogleCalendar); // 📅 Módulo Google Calendar
        } else {
          // ✅ CORREÇÃO: Se não encontrar plano, OCULTAR funcionalidades (seguro)
          setShowCampaigns(false);
          setShowKanban(false);
          setShowOpenAi(false);
          setShowIntegrations(false);
          setShowSchedules(false);
          setShowInternalChat(false);
          setShowExternalApi(false);
          setShowIFood(false); // ✅ Módulo iFood
          setShowSipPhone(false); // ✅ Módulo SIP Phone
          setShowWaba(false); // ✅ Templates WABA
          setShowEmail(false); // ✅ Módulo Email
          setShowGoogleCalendar(false); // 📅 Módulo Google Calendar
        }

        // Buscar configurações da empresa para verificar carteirização
        try {
          const { data: companySettings } = await api.get(`/companies-settings/${companyId}`);
          setShowContactWallet(companySettings?.contactWalletEnabled === "enabled");
        } catch (settingsError) {
          // Se falhar ao buscar settings, mostrar menu (validação acontece no backend)
          console.warn("[MainListItems] Erro ao buscar settings, mantendo menu visível:", settingsError?.message);
          setShowContactWallet(true); // Fallback seguro: mostrar menu
        }
      } catch (error) {
        // ✅ CORREÇÃO: Em caso de erro, OCULTAR funcionalidades (seguro)
        console.error("[MainListItems] Erro ao buscar plano da empresa:", error);
        setShowCampaigns(false);
        setShowKanban(false);
        setShowOpenAi(false);
        setShowIntegrations(false);
        setShowSchedules(false);
        setShowInternalChat(false);
        setShowExternalApi(false);
        setShowContactWallet(false);
        setShowIFood(false); // ✅ Módulo iFood
        setShowSipPhone(false); // ✅ Módulo SIP Phone
        setShowWaba(false); // ✅ Templates WABA
        setShowEmail(false); // ✅ Módulo Email
        
        // Não fazer retry automático - usuário deve recarregar página se necessário
      }
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.companyId]);

  // 🔄 Atualizar menu imediatamente quando um plano for alterado
  useEffect(() => {
    if (!user?.companyId) return;
    const handler = async () => {
      try {
        const planConfigs = await getPlanCompany(undefined, user.companyId);
        if (planConfigs && planConfigs.plan) {
          setShowCampaigns(planConfigs.plan.useCampaigns);
          setShowKanban(planConfigs.plan.useKanban);
          setShowOpenAi(planConfigs.plan.useOpenAi);
          setShowIntegrations(planConfigs.plan.useIntegrations);
          setShowSchedules(planConfigs.plan.useSchedules);
          setShowInternalChat(planConfigs.plan.useInternalChat);
          setShowExternalApi(planConfigs.plan.useExternalApi);
          setShowIFood(planConfigs.plan.useIFood);
          setShowSipPhone(planConfigs.plan.useSipPhone);
          setShowWaba(planConfigs.plan.useWaba);
          setShowEmail(planConfigs.plan.useEmail);
          setShowGoogleCalendar(planConfigs.plan.useGoogleCalendar);
        }
      } catch (_) {
        // manter estado atual; fallback seguro já existe no fetch inicial
      }
    };
    document.addEventListener("plan:changed", handler);
    return () => document.removeEventListener("plan:changed", handler);
  }, [getPlanCompany, user?.companyId]);

  // ✅ Socket.IO: Atualizar menu em tempo real quando settings mudarem
  useEffect(() => {
    if (!socket || !user?.companyId) return;

    const handleSettingsUpdate = (data) => {
      // Atualizar apenas quando a configuração de carteirização mudar
      if (data.action === "update" && 
          data.companySetting?.key === "contactWalletEnabled") {
        const newValue = data.companySetting.value === "enabled";
        setShowContactWallet(newValue);
        console.log(`[MainListItems] Menu Carteiras atualizado: ${newValue ? "Habilitado" : "Desabilitado"}`);
      }
    };

    socket.on(`company-${user.companyId}-settings`, handleSettingsUpdate);

    return () => {
      socket.off(`company-${user.companyId}-settings`, handleSettingsUpdate);
    };
  }, [socket, user?.companyId]);

  useEffect(() => {
    if (location.pathname.startsWith("/tickets")) {
      setActiveMenu("/tickets");
    } else {
      setActiveMenu("");
    }
  }, [location, setActiveMenu]);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    // ✅ FIX: Verificar se socket existe antes de usar
    if (user.id && socket) {
      const companyId = user.companyId;
      const onCompanyChatMainListItems = (data) => {
        if (data.action === "new-message") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
      };

      socket.on(`company-${companyId}-chat`, onCompanyChatMainListItems);
      return () => {
        socket.off(`company-${companyId}-chat`, onCompanyChatMainListItems);
      };
    }
  }, [socket, user.id, user.companyId]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  // ✅ Verificar se há conexões wuzapi COM grupos habilitados E usuário tem permissão
  useEffect(() => {
    if (whatsApps && whatsApps.length > 0) {
      // Mostrar menu de grupos apenas se:
      // 1. Houver conexão wuzapi/whatsapp (baileys) COM "Permitir Grupos" ativado
      // 2. E o usuário logado tiver permissão de grupos (user.allowGroup)
      // WABA não suporta gerenciamento de grupos via API
      const hasWuzapiWithGroups = whatsApps.some(w => 
        (w.channel === "wuzapi" || w.channel === "whatsmeow" || w.channel === "whatsapp" || !w.channel) && 
        w.allowGroup === true
      );
      // Admin/Super sempre podem ver se há conexão com grupos
      // Usuários comuns precisam ter allowGroup = true
      const userCanSeeGroups = isAdminProfile(user) || user.allowGroup === true;
      setShowWhatsAppGroups(hasWuzapiWithGroups && userCanSeeGroups);
      
      // 🆕 Comunidades WhatsApp - apenas whatsmeow conectado
      const hasWhatsmeowConnected = whatsApps.some(w => 
        w.channel === "whatsmeow" && w.status === "CONNECTED"
      );
      setShowWhatsAppCommunities(hasWhatsmeowConnected && userCanSeeGroups);
    } else {
      setShowWhatsAppGroups(false);
      setShowWhatsAppCommunities(false);
    }
  }, [whatsApps, user]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  const getConnectionStatusClass = () => {
    if (!connectionWarning) return "success";

    const offlineWhats = whatsApps.filter((whats) => {
      return whats.status === "DISCONNECTED" || whats.status === "TIMEOUT";
    });

    if (offlineWhats.length > 0) {
      return "error";
    }

    return "warning";
  };

  const getConnectionStatusText = () => {
    const disconnectedCount = whatsApps.filter((whats) => {
      return (
        whats.status === "qrcode" ||
        whats.status === "PAIRING" ||
        whats.status === "DISCONNECTED" ||
        whats.status === "TIMEOUT" ||
        whats.status === "OPENING"
      );
    }).length;

    const connectedCount = whatsApps.length - disconnectedCount;

    if (disconnectedCount > 0) {
      return `${connectedCount}/${whatsApps.length}`;
    }

    return i18n.t("connections.check");
  };

  const getConnectionStatusIcon = () => {
    if (!connectionWarning) return <Wifi className="connection-icon" />;

    const offlineWhats = whatsApps.filter((whats) => {
      return whats.status === "DISCONNECTED" || whats.status === "TIMEOUT";
    });

    if (offlineWhats.length > 0) {
      return <WifiOff className="connection-icon" />;
    }

    return <AlertTriangle className="connection-icon" />;
  };

  const renderMenuItem = (to, text, icon, showBadge = false) => (
    <Link
      to={to}
      className="dropdown-menu-item"
      onClick={() => handleMenuItemClick(to)}
    >
      <div className="menu-item-icon">
        {showBadge ? (
          <div className="badge-container">
            {icon}
            <span className="badge">!</span>
          </div>
        ) : (
          icon
        )}
      </div>
      <span className="menu-item-text">{text}</span>
      {to === "/connections" && connectionWarning && (
        <Tooltip
          title={i18n.t("connections.title") + ": " + getConnectionStatusText()}
          placement="right"
          arrow
        >
          <div className={`connection-status ${getConnectionStatusClass()}`}>
            {getConnectionStatusIcon()}
            <span>{getConnectionStatusText()}</span>
          </div>
        </Tooltip>
      )}
    </Link>
  );

  const menuPermissions = user?.menuPermissions || [];

  const hasMenuPermission = (permissionKey) => {
    // ✅ Apenas admin/super têm acesso total - supervisores respeitam permissões
    if (isFullAdmin(user)) {
      return true;
    }

    if (!permissionKey) {
      return true;
    }

    const hasPermission = menuPermissions.includes(permissionKey);
    return hasPermission;
  };

  const renderProtectedMenuItem = (permissionKey, to, text, icon, showBadge = false) => {
    if (!hasMenuPermission(permissionKey)) {
      return null;
    }

    return renderMenuItem(to, text, icon, showBadge);
  };

  const hasAnyPermissionInCategory = (categoryPrefix) => {
    // ✅ Apenas admin/super têm acesso total - supervisores respeitam permissões
    if (isFullAdmin(user)) {
      return true;
    }
    const hasPermission = menuPermissions.some(permission => permission.startsWith(categoryPrefix));
    return hasPermission;
  };

  return (
    <div
      className={`main-list-items ${isMobile ? "mobile" : ""} ${
        isDarkMode ? "dark" : ""
      }`}
    >
      {/* 1. ADMINISTRAÇÃO */}
      {hasAnyPermissionInCategory("administration") && (
        <div className="dropdown-container" ref={adminContainerRef}>
          <button
            ref={adminButtonRef}
            className={`nav-button ${isAdminActive ? "active" : ""}`}
            onClick={toggleAdminMenu}
          >
            <Cog className="nav-button-icon" />
            <span>{i18n.t("mainDrawer.listItems.administration")}</span>
            {isMobile && (
              <ChevronDown
                className={`dropdown-icon ${adminMenuOpen ? "open" : ""}`}
              />
            )}
          </button>
          <div
            ref={adminMenuRef}
            className={`dropdown-menu ${
              isMobile && adminMenuOpen ? "open" : ""
            }`}
          >
            {/* ✅ ORDEM PERSONALIZADA conforme solicitado pelo usuário */}
            {/* 1. Usuários */}
            {renderProtectedMenuItem(
              "administration.users",
              "/users",
              i18n.t("mainDrawer.listItems.users"),
              <Users className="hero-icon" />
            )}
            {/* 2. Filas e Setores */}
            {renderProtectedMenuItem(
              "administration.queues",
              "/queues",
              i18n.t("mainDrawer.listItems.queues"),
              <ListOrdered className="hero-icon" />
            )}
            {/* 3. Configurações */}
            {renderProtectedMenuItem(
              "administration.settings",
              "/settings",
              i18n.t("mainDrawer.listItems.settings"),
              <Settings className="hero-icon" />
            )}
            {/* 4. Backup & Restore */}
            {renderProtectedMenuItem(
              "administration.backupRestore",
              "/backup-restore",
              "Backup & Restore",
              <Database className="hero-icon" />
            )}
            {/* 4.1 Configurar App Mobile (QR de onboarding do servidor) */}
            {isAdminProfile(user) && (
              <Link
                to="/mobile-app-qr"
                className="dropdown-menu-item"
                onClick={() => handleMenuItemClick("/mobile-app-qr")}
              >
                <div className="menu-item-icon">
                  <Smartphone className="hero-icon" />
                </div>
                <span className="menu-item-text">Configurar App Mobile</span>
              </Link>
            )}
            {/* 5. Lista de Arquivos */}
            {renderProtectedMenuItem(
              "administration.files",
              "/files",
              i18n.t("mainDrawer.listItems.files"),
              <Paperclip className="hero-icon" />
            )}
            {/* 6. Empresas - Apenas Admin Super */}
            {user?.super && renderProtectedMenuItem(
              "administration.companies",
              "/companies",
              i18n.t("mainDrawer.listItems.companies"),
              <Building2 className="hero-icon" />
            )}
            {/* 6.1 Painel Financeiro - Apenas Admin Super */}
            {user?.super && renderProtectedMenuItem(
              "administration.financial",
              "/admin-financeiro",
              "Painel Financeiro",
              <Wallet className="hero-icon" />
            )}
            {/* 7. Gerenciar Armazenamento */}
            {renderProtectedMenuItem(
              "administration.storageManagement",
              "/storage-management",
              i18n.t("storageManagement.manage"),
              <HardDrive className="hero-icon" />
            )}
            {/* 8. Permissões de Perfil */}
            {renderProtectedMenuItem(
              "administration.profilePermissions",
              "/profile-permissions",
              i18n.t("mainDrawer.listItems.profilePermissions"),
              <Shield className="hero-icon" />
            )}
            {/* 9. Logs de Auditoria - Apenas Admin */}
            {user?.profile === "admin" && (
              <Link
                to="/audit-logs"
                className="dropdown-menu-item"
                onClick={() => handleMenuItemClick("/audit-logs")}
              >
                <div className="menu-item-icon">
                  <Shield className="hero-icon" />
                </div>
                <span className="menu-item-text">Auditoria</span>
              </Link>
            )}
          </div>
        </div>
      )}

      {/* 2. ATENDIMENTOS */}
      {hasAnyPermissionInCategory("tickets") && (
      <div className="dropdown-container" ref={ticketsContainerRef}>
        <button
          ref={ticketsButtonRef}
          className={`nav-button ${isTicketsActive ? "active" : ""}`}
          onClick={toggleTicketsMenu}
        >
          <MessageSquare className="nav-button-icon" />
          <span>{i18n.t("mainDrawer.listItems.tickets")}</span>
          {isMobile && (
            <ChevronDown
              className={`dropdown-icon ${ticketsMenuOpen ? "open" : ""}`}
            />
          )}
        </button>

        <div
          ref={ticketsMenuRef}
          className={`dropdown-menu ${
            isMobile && ticketsMenuOpen ? "open" : ""
          }`}
        >
          {/* ✅ ORDEM PERSONALIZADA conforme solicitado pelo usuário */}
          {/* 1. Atendimento */}
          {renderProtectedMenuItem(
            "tickets.tickets",
            "/tickets",
            i18n.t("mainDrawer.listItems.tickets"),
            <MessagesSquare className="hero-icon" />
          )}
          {/* 2. Agendamentos (Mensagens Agendadas ou Google Calendar) */}
          {(showSchedules || showGoogleCalendar) &&
            renderProtectedMenuItem(
              "tickets.schedules",
              "/schedules",
              i18n.t("mainDrawer.listItems.schedules"),
              <Clock className="hero-icon" />
            )}
          {/* 2.5. Callbacks de Voz - Só aparece se o usuário tem VoIP habilitado */}
          {user?.voipEnabled && user?.voipExtension &&
            renderProtectedMenuItem(
              "tickets.callbacks",
              "/callbacks",
              i18n.t("mainDrawer.listItems.callbacks") || "Callbacks",
              <PhoneIncoming className="hero-icon" />
            )
          }
          {/* 3. Ajuda */}
          {hasHelps &&
            renderProtectedMenuItem(
              "tickets.helps",
              "/helps",
              i18n.t("mainDrawer.listItems.helps"),
              <HelpCircle className="hero-icon" />
            )}
          {/* 4. Contatos */}
          {renderProtectedMenuItem(
            "tickets.contacts",
            "/contacts",
            i18n.t("mainDrawer.listItems.contacts"),
            <User className="hero-icon" />
          )}
          {/* 5. Carteiras de Contatos */}
          {showContactWallet && renderProtectedMenuItem(
            "tickets.contactWallets",
            "/contact-wallets",
            i18n.t("contactWallets.title"),
            <Briefcase className="hero-icon" />
          )}
          {/* 6. Respostas Rápidas */}
          {renderProtectedMenuItem(
            "tickets.quickMessages",
            "/quick-messages",
            i18n.t("mainDrawer.listItems.quickMessages"),
            <Zap className="hero-icon" />
          )}
          {/* 7. Tags */}
          {renderProtectedMenuItem(
            "tickets.tags",
            "/tags",
            i18n.t("mainDrawer.listItems.tags"),
            <Tag className="hero-icon" />
          )}
        </div>
      </div>
      )}

      {/* 3. AUTOMAÇÃO */}
      {hasAnyPermissionInCategory("automation") && (
        <div className="dropdown-container" ref={automationContainerRef}>
          <button
            ref={automationButtonRef}
            className={`nav-button ${isAutomationActive ? "active" : ""}`}
            onClick={toggleAutomationMenu}
          >
            <Workflow className="nav-button-icon" />
            <span>Automação</span>
            {isMobile && (
              <ChevronDown
                className={`dropdown-icon ${automationMenuOpen ? "open" : ""}`}
              />
            )}
          </button>
          <div
            ref={automationMenuRef}
            className={`dropdown-menu ${
              isMobile && automationMenuOpen ? "open" : ""
            }`}
          >
            {/* Itens em ordem alfabética */}
            {renderProtectedMenuItem(
              "automation.flowbuilder",
              "/flows",
              "Flow Builder",
              <Workflow className="hero-icon" />
            )}
            {showIntegrations &&
              renderProtectedMenuItem(
                "automation.googleSpeech",
                "/integrations/google-speech",
                "Google Speech-to-Text",
                <Mic className="hero-icon" />
              )
            }
            {showIntegrations && user?.voipEnabled && user?.voipExtension &&
              renderProtectedMenuItem(
                "automation.voiceApi",
                "/integrations/voice-api",
                i18n.t("mainDrawer.listItems.voiceApi") || "Voice AI API",
                <PhoneIncoming className="hero-icon" />
              )
            }
            {showExternalApi &&
              renderProtectedMenuItem(
                "automation.messagesAPI",
                "/messages-api",
                i18n.t("mainDrawer.listItems.messagesAPI"),
                <Code className="hero-icon" />
              )
            }
            {showExternalApi &&
              renderProtectedMenuItem(
                "automation.publicApi",
                "/integrations/public-api",
                i18n.t("mainDrawer.listItems.publicApi") || "API Pública v1",
                <Code className="hero-icon" />
              )
            }
            {showIntegrations &&
              renderProtectedMenuItem(
                "automation.queueIntegration",
                "/queue-integration",
                i18n.t("mainDrawer.listItems.queueIntegration"),
                <Cable className="hero-icon" />
              )
            }
            {/* Talk.AI - Configurações de IA Multi-Provedor */}
            {showOpenAi &&
              renderProtectedMenuItem(
                "automation.talkAI",
                "/ai-configurations",
                i18n.t("mainDrawer.listItems.prompts"),
                <Sparkles className="hero-icon" />
              )
            }
            {/* AI Tools Framework - Integrações com Sistemas Externos */}
            {showOpenAi &&
              renderProtectedMenuItem(
                "automation.aiTools",
                "/ai-tools",
                i18n.t("mainDrawer.listItems.aiTools"),
                <Wrench className="hero-icon" />
              )
            }
            {/* Unbrowse Web Sessions */}
            {showOpenAi &&
              renderProtectedMenuItem(
                "automation.aiTools",
                "/ai-tools/web-sessions",
                "Sessões Web",
                <Globe className="hero-icon" />
              )
            }
            {showOpenAi &&
              renderProtectedMenuItem(
                "automation.aiTools",
                "/ai-playground",
                "AI Playground",
                <FlaskConical className="hero-icon" />
              )
            }
          </div>
        </div>
      )}

      {/* 4. CAMPANHAS */}
      {showCampaigns && hasAnyPermissionInCategory("campaigns") && (
        <div className="dropdown-container" ref={campaignsContainerRef}>
            <button
              ref={campaignsButtonRef}
              className={`nav-button ${isCampaignRouteActive ? "active" : ""}`}
              onClick={toggleCampaignsMenu}
            >
              <Megaphone className="nav-button-icon" />
              <span>{i18n.t("mainDrawer.listItems.campaigns")}</span>
              {isMobile && (
                <ChevronDown
                  className={`dropdown-icon ${campaignsMenuOpen ? "open" : ""}`}
                />
              )}
            </button>

            <div
              ref={campaignsMenuRef}
              className={`dropdown-menu ${
                isMobile && campaignsMenuOpen ? "open" : ""
              }`}
            >
              {/* Itens em ordem alfabética */}
              {renderProtectedMenuItem(
                "campaigns.campaigns",
                "/campaigns",
                i18n.t("campaigns.subMenus.list"),
                <List className="hero-icon" />
              )}
              {renderProtectedMenuItem(
                "campaigns.contactLists",
                "/contact-lists",
                i18n.t("campaigns.subMenus.listContacts"),
                <UsersRound className="hero-icon" />
              )}
              {renderProtectedMenuItem(
                "campaigns.templates",
                "/campaign-templates",
                "Templates",
                <FileStack className="hero-icon" />
              )}
              {renderProtectedMenuItem(
                "campaigns.blacklist",
                "/campaign-blacklist",
                "Blacklist",
                <Ban className="hero-icon" />
              )}
            </div>
          </div>
      )}

      {/* 5. CONEXÕES */}
      {hasAnyPermissionInCategory("connections") && (
        <div className="dropdown-container" ref={connectionsContainerRef}>
          <button
            ref={connectionsButtonRef}
            className={`nav-button ${isConnectionsActive ? "active" : ""}`}
            onClick={toggleConnectionsMenu}
          >
            <ArrowLeftRight className="nav-button-icon" />
            <span>Conexões</span>
            {isMobile && (
              <ChevronDown
                className={`dropdown-icon ${connectionsMenuOpen ? "open" : ""}`}
              />
            )}
          </button>
          <div
            ref={connectionsMenuRef}
            className={`dropdown-menu ${
              isMobile && connectionsMenuOpen ? "open" : ""
            }`}
          >
            {/* Itens em ordem alfabética */}
            {renderProtectedMenuItem(
              "connections.connections",
              "/connections",
              i18n.t("mainDrawer.listItems.connections"),
              <ArrowLeftRight className="hero-icon" />,
              connectionWarning
            )}
            {/* 🆕 Grupos WhatsApp - apenas se houver conexão wuzapi/whatsapp/whatsmeow */}
            {showWhatsAppGroups && renderProtectedMenuItem(
              "connections.whatsappGroups",
              "/whatsapp-groups",
              i18n.t("mainDrawer.listItems.whatsappGroups"),
              <UsersRound className="hero-icon" />
            )}
            {/* 🆕 Comunidades WhatsApp - apenas se houver conexão whatsmeow */}
            {showWhatsAppCommunities && renderProtectedMenuItem(
              "connections.whatsappCommunities",
              "/whatsapp-communities",
              "Comunidades",
              <Users className="hero-icon" />
            )}
            {/* Email - Templates agora acessível via ícone no card de email na página de Conexões */}
            {/* Gerenciar Conexões - Apenas Admin Super */}
            {user?.super && renderProtectedMenuItem(
              "connections.allConnections",
              "/allConnections",
              i18n.t("mainDrawer.listItems.allConnections"),
              <Server className="hero-icon" />
            )}
          </div>
        </div>
      )}

      {/* 6. GESTÃO */}
      {hasAnyPermissionInCategory("management") && (
        <div className="dropdown-container" ref={managementContainerRef}>
          <button
            ref={managementButtonRef}
            className={`nav-button ${isManagementActive ? "active" : ""}`}
            onClick={toggleManagementMenu}
          >
            <Home className="nav-button-icon" />
            <span>{i18n.t("mainDrawer.listItems.management")}</span>
            {isMobile && (
              <ChevronDown
                className={`dropdown-icon ${managementMenuOpen ? "open" : ""}`}
              />
            )}
          </button>

          <div
            ref={managementMenuRef}
            className={`dropdown-menu ${
              isMobile && managementMenuOpen ? "open" : ""
            }`}
          >
            {/* Itens em ordem alfabética */}
            {renderProtectedMenuItem(
              "management.announcements",
              "/announcements",
              i18n.t("mainDrawer.listItems.annoucements"),
              <Info className="hero-icon" />
            )}
            {renderProtectedMenuItem(
              "management.dashboard",
              "/dashboard",
              "Dashboard",
              <BarChart3 className="hero-icon" />
            )}
            {/* Tarefas */}
            {renderProtectedMenuItem(
              "management.tasks",
              "/tasks",
              i18n.t("mainDrawer.listItems.tasks") || "Tarefas",
              <ClipboardList className="hero-icon" />
            )}
            
            {/* ============================================ */}
            {/* SUBMENU FUNIL - Agrupa Kanban, Leads, Automações, Jornada */}
            {/* ============================================ */}
            {showKanban && (hasMenuPermission("management.funnel") || hasMenuPermission("management.funnel.kanban") || hasMenuPermission("management.funnel.leads") || hasMenuPermission("management.funnel.automations") || hasMenuPermission("management.funnel.journey")) && (
              <div className="submenu-container">
                <button
                  className={`submenu-trigger ${isFunnelActive ? "active" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setFunnelSubmenuOpen(!funnelSubmenuOpen);
                  }}
                >
                  <div className="submenu-trigger-content">
                    <div className="menu-item-icon">
                      <Filter className="hero-icon" />
                    </div>
                    <span style={{ fontWeight: 600 }}>Funil</span>
                  </div>
                  <ChevronRight className={`submenu-arrow ${funnelSubmenuOpen ? "open" : ""}`} />
                </button>
                
                <div className={`submenu-dropdown ${funnelSubmenuOpen ? "open" : ""}`}>
                  {/* Kanban */}
                  {renderProtectedMenuItem(
                    "management.funnel.kanban",
                    "/kanban",
                    i18n.t("mainDrawer.listItems.kanban"),
                    <Columns className="hero-icon" />
                  )}
                  {/* Leads Dashboard */}
                  {renderProtectedMenuItem(
                    "management.funnel.leads",
                    "/leads",
                    i18n.t("mainDrawer.listItems.leads") || "Leads",
                    <TrendingUp className="hero-icon" />
                  )}
                  {/* Automações */}
                  {renderProtectedMenuItem(
                    "management.funnel.automations",
                    "/automations",
                    i18n.t("mainDrawer.listItems.automations") || "Automações",
                    <Zap className="hero-icon" />
                  )}
                  {/* Jornada do Cliente */}
                  {renderProtectedMenuItem(
                    "management.funnel.journey",
                    "/journey",
                    i18n.t("mainDrawer.listItems.journey") || "Jornada",
                    <Workflow className="hero-icon" />
                  )}
                </div>
              </div>
            )}
            
            {/* Financeiro - Faturas e Pagamentos (Admin/Super apenas) */}
            {isAdminProfile(user) &&
              renderMenuItem(
                "/financeiro",
                "Financeiro",
                <CreditCard className="hero-icon" />
              )}
            {renderProtectedMenuItem(
              "management.moments",
              "/moments",
              i18n.t("mainDrawer.listItems.chatsTempoReal"),
              <Table className="hero-icon" />
            )}
            {renderProtectedMenuItem(
              "management.reports",
              "/reports",
              i18n.t("mainDrawer.listItems.reports"),
              <FileText className="hero-icon" />
            )}
            {renderProtectedMenuItem(
              "management.reports",
              "/reports-advanced",
              "Relatórios Avançados",
              <BarChart2 className="hero-icon" />
            )}
            {/* Smart AI Agents - Dashboard de Agentes Autônomos */}
            {showOpenAi &&
              renderProtectedMenuItem(
                "management.smartAI",
                "/smart-ai-dashboard",
                "Smart AI",
                <Bot className="hero-icon" />
              )
            }
            {renderProtectedMenuItem(
              "management.ticketClassification",
              "/ticket-classification",
              "Classificação de Tickets",
              <Tag className="hero-icon" />
            )}
            {renderProtectedMenuItem(
              "management.ticketTabs",
              "/ticket-tabs-settings",
              "Abas de Atendimento",
              <Columns className="hero-icon" />
            )}
          </div>
        </div>
      )}

      {/* ============================================ */}
      {/* 7. IFOOD - Só aparece se habilitado no plano */}
      {/* ============================================ */}
      {showIFood && hasAnyPermissionInCategory("ifood") && (
        <div className="dropdown-container" ref={ifoodButtonRef}>
          <button
            className={`nav-button ${isIfoodActive ? "active" : ""}`}
            onClick={toggleIfoodMenu}
          >
            <UtensilsCrossed className="nav-button-icon" />
            <span>iFood</span>
            {isMobile && (
              <ChevronDown
                className={`dropdown-icon ${ifoodMenuOpen ? "open" : ""}`}
              />
            )}
          </button>

          <div
            ref={ifoodMenuRef}
            className={`dropdown-menu ${
              isMobile && ifoodMenuOpen ? "open" : ""
            }`}
          >
            {/* Pedidos */}
            {renderProtectedMenuItem(
              "ifood.orders",
              "/ifood/orders",
              "Pedidos",
              <ShoppingBag className="hero-icon" />
            )}
            {/* Cardápio */}
            {renderProtectedMenuItem(
              "ifood.catalog",
              "/ifood/catalog",
              "Cardápio",
              <Coffee className="hero-icon" />
            )}
            {/* Avaliações */}
            {renderProtectedMenuItem(
              "ifood.reviews",
              "/ifood/reviews",
              "Avaliações",
              <Star className="hero-icon" />
            )}
            {/* Financeiro */}
            {renderProtectedMenuItem(
              "ifood.financial",
              "/ifood/financial",
              "Financeiro",
              <DollarSign className="hero-icon" />
            )}
            {/* Promoções */}
            {renderProtectedMenuItem(
              "ifood.promotions",
              "/ifood/promotions",
              "Promoções",
              <Percent className="hero-icon" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MainListItems;
